module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "CN",
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062365606_Contents#rpt1"
    }
  }, [_vm._v("part one")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-headings_PTO1_Part_title_2"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062365606_Contents#rpt1"
    }
  }, [_vm._v("ENGLAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "FME1_Frontmatter_epigraph_other_1"
  }, [_vm._v("The sweet habit of each other had begun to put lines around her mouth, lines that looked like quotation marks – as if everything she said had been said before.")]), _vm._v(" "), _c('p', {
    staticClass: "FME2_Frontmatter_epigraph_other_2"
  }, [_vm._v("Lorrie Moore, "), _c('i', [_vm._v("Agnes of Iowa")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eac77c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062365606_Part_1.vue
// module id = 75
// module chunks = 0